import { render, staticRenderFns } from "./CopyProject.vue?vue&type=template&id=0ad7b058"
import script from "./CopyProject.vue?vue&type=script&lang=js"
export * from "./CopyProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports